// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"40":"css/reset","2403":"css/bootstrap","3835":"css/review","8252":"css/app","8962":"css/landingspage"}[chunkId] + ".css";
};